import { render, staticRenderFns } from "./errorMessage.vue?vue&type=template&id=bdcc9656&scoped=true"
import script from "./errorMessage.vue?vue&type=script&lang=js"
export * from "./errorMessage.vue?vue&type=script&lang=js"
import style0 from "./errorMessage.vue?vue&type=style&index=0&id=bdcc9656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc9656",
  null
  
)

export default component.exports